import { PicklistItem } from '~/types'

const initialState = {
  data: undefined,
}

export const SET_PICKLISTS = 'SET_PICKLISTS'
export const MUTATE_PICKLIST = 'MUTATE_PICKLIST'

export function setPicklists(data) {
  return {
    type: SET_PICKLISTS,
    payload: data,
  } as const
}

export function mutatePicklist(picklistKey: string, item: PicklistItem) {
  return {
    type: MUTATE_PICKLIST,
    payload: {
      picklistKey,
      item,
    },
  } as const
}

type ActionTypes =
  | ReturnType<typeof setPicklists>
  | ReturnType<typeof mutatePicklist>

export default function picklistsReducer(
  state = initialState,
  action: ActionTypes
) {
  switch (action.type) {
    case 'SET_PICKLISTS':
      return {
        ...state,
        data: action.payload,
      }
    default:
      return state
  }
}
